let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbOxz")).then(() => parcelRequire('bXRsw'));